import { useQuery } from "@tanstack/react-query"
import releaseInformationService from "services/releaseInformation.service"

export const useGetReleases = () => {
	return useQuery({
		queryKey: ["releaseInformation"],
		queryFn: () => releaseInformationService.getReleases(),
		select: ({ data }) => data,
	})
}
